import { Link } from "react-router";
import { BlastLogo } from "./assets/BlastLogo";
import { useGetMetadata } from "../../../data/metadata/getMetadata/useGetMetadata";
import { useMemo } from "react";
import { games } from "../../../data/metadata/games";

export const Navbar = () => {
  const { data } = useGetMetadata();

  const gamesWithData = useMemo(() => {
    if (!data) return [];
    return games.filter((game) => data.categories[game.id]?.length);
  }, [data]);

  return (
    <nav className="sticky top-0 z-10 box-content bg-canvas-100 shadow">
      <div className="mx-auto flex h-16 max-w-8xl items-center gap-8 px-4 md:px-6">
        <Link to="/" className="transition-transform hover:scale-90">
          <BlastLogo />
        </Link>
        {gamesWithData.map((game) => (
          <Link
            to={`/assets/${game.id}`}
            key={game.id}
            className="text-neutral-0 transition-all font-style-navigation-desktop hover:text-neutral-10"
          >
            {game.name}
          </Link>
        ))}
        <a
          className="ml-auto text-neutral-0 transition-all font-style-navigation-desktop hover:text-neutral-10"
          href="https://blast.tv/fankit/content-policy"
          target="_blank"
          rel="noreferrer"
        >
          Media Kit Policy
        </a>
      </div>
    </nav>
  );
};
